// KeyPointVerticalNumericFourMobileComponent.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollFadeWrapper, {
  ScrollFadeSection,
} from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import LinkWithIconComponent from '../LinkWithIcon/LinkWithIconComponent';
import Image from '../../Image/Image';

// Cloudflare CDN KeyPoint vector
const KEYPOINT_VECTOR_URL =
  'https://assets.askhippo.co.za/Vectors/KeyPointVerticalVector.svg';

const KeyPointVerticalNumericFourMobileComponent = ({ data }) => {
  const { title, description, descriptionLink, footer, footerLink, steps } =
    data;

  return (
    <ScrollFadeSection
      sx={{
        width: '100%',
        maxWidth: '100vw',
        backgroundColor: '#F3F6F6',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0 16px',
        boxSizing: 'border-box',
        gap: '32px',
      }}
    >
      {/* Blue Info Box */}
      <Box
        sx={{
          width: '100%',
          backgroundColor: '#162F3B',
          borderRadius: '34px',
          padding: '32px 16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
          alignItems: 'center',
        }}
      >
        <ScrollFadeWrapper variant="text">
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 700,
              fontSize: '2rem',
              lineHeight: '2.25rem',
              color: '#FFFFFF',
              textAlign: 'center',
              letterSpacing: '-0.03em',
            }}
          >
            {title}
          </Typography>
        </ScrollFadeWrapper>

        <ScrollFadeWrapper variant="text" delay={0.2}>
          <LinkWithIconComponent
            href={descriptionLink || undefined}
            component={descriptionLink ? 'a' : 'p'}
            showIcon={Boolean(descriptionLink)}
            iconSrc="https://assets.askhippo.co.za/Icons/common/Union.svg"
            iconSize="0.875rem"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: '1.25rem',
              lineHeight: '1.5rem',
              color: '#FFFFFF',
              textAlign: 'center',
              letterSpacing: '-0.03em',
              px: '16px',
              boxSizing: 'border-box',
              alignSelf: 'stretch',
              whiteSpace: 'pre-line',
            }}
          >
            {description}
          </LinkWithIconComponent>
        </ScrollFadeWrapper>

        <LinkWithIconComponent
          href={footerLink || undefined}
          iconSrc="https://assets.askhippo.co.za/Icons/common/Union.svg"
          iconSize="0.75rem"
          sx={{
            mb: '15px',
            textAlign: 'center',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: '0.75rem',
            lineHeight: '1.25rem',
            letterSpacing: '-0.001em',
            color: '#FFFFFF',
          }}
        >
          {footer}
        </LinkWithIconComponent>
      </Box>

      {/* Numbered Step Cards */}
      {steps.map(({ title, text }, i) => (
        <ScrollFadeWrapper
          key={i}
          delay={0.4 + i * 0.08}
          sx={{
            width: '100%',
            alignSelf: 'stretch',
          }}
        >
          <Box
            sx={{
              width: '100%',
              alignSelf: 'stretch',
              backgroundColor: '#FFFFFF',
              borderRadius: '34px',
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              boxShadow: '0px 3px 8px 0px #162F3B1F, 0px 1px 2px 0px #A2ACB133',
            }}
          >
            <Box sx={{ position: 'relative', width: '80px', height: '80px' }}>
              {/* Cloudflare Vector */}
              <Image
                width={80}
                height={80}
                src={KEYPOINT_VECTOR_URL}
                alt="Key point illustration (vertical)"
                sx={{ width: '100%', height: '100%' }}
              />

              <Typography
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  fontFamily: 'Pally, Inter, sans-serif',
                  fontWeight: 700,
                  fontSize: '2.5rem',
                  lineHeight: '2.5rem',
                  color: '#162F3B',
                  letterSpacing: '-0.001em',
                }}
              >
                {i + 1}
              </Typography>
            </Box>

            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 700,
                fontSize: '1.25rem',
                lineHeight: '1.5rem',
                color: '#162F3B',
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: '1rem',
                lineHeight: '1.5rem',
                color: '#162F3B',
                letterSpacing: '-0.02em',
              }}
            >
              {text}
            </Typography>
          </Box>
        </ScrollFadeWrapper>
      ))}
    </ScrollFadeSection>
  );
};

export default KeyPointVerticalNumericFourMobileComponent;
